module.exports = "/images/sad.png?fc4110a39e45524d3a60e9271bfc1956";